import BaseService from './base.service';

export default class ShareholerRelationshipCategoryService extends BaseService {
    constructor(ctx) {
        super(ctx);
    }

    getShareholerRelationshipCategoryOptions = (query = {}) => {
        return this.get('/shareholder-relationship/get-options', query);
    };
}
